export const whatsappConversationSharedLocalizations = {
  pt: {
    conversationTooltips: {
      freeTier: 'As primeiras conversas gratuitas de cada mês por WABA (WhatsApp Business Account)',
      freeEntryPoint:
        'Conversas iniciadas em pontos específicos, como anúncios direcionados ao WhatsApp e CTAs via Facebook. Nesses casos, apenas a primeira conversa iniciada pelo usuário é gratuita',
      freeCustomerService: 'Conversas de atendimento ao cliente pelo WhatsApp não têm custo',
      allConversations: 'O número de mensagens que sua empresa enviou para contas individuais e que foram entregues com sucesso. Essa métrica contabiliza apenas as mensagens que chegaram ao dispositivo do destinatário e exclui as mensagens que não foram entregues, por exemplo, quando o dispositivo do destinatário estava fora de serviço.',
      billedConversations: 'O número de mensagens pagas entregues com sucesso a conta individuais do WhatsApp. Uma mensagem entregue significa que uma mensagem da empresa foi entregue a alguém no WhatsApp. A mensagem pode ser de marketing, utilidade ou autenticação.',
      regularConversations: 'São aquelas conversas realizadas por mensagens de WhatsApp, entre empresa e usuários, que são cobradas. Uma conversa inclui todas as mensagens trocadas dentro de um período de 24 horas, começando quando a primeira mensagem enviada pela empresa é entregue.',
    },
    labels: {
      freeEntryPoint: 'Ponto de entrada gratuito',
      freeCustomerService: 'Atendimento ao cliente grátis',
      charged: 'Pagas',
      businessInitiated: 'Mensagens entregues pagas',
      userInitiated: 'Mensagens entregues gratuitas',
      totalConversations: 'Mensagens entregues',
    },
    descriptions: {
      freeTierUsage: 'Uso do free tier',
      chargedConversations: 'Mensagens pagas',
      totalBusinessInitiated: 'Total de mensagens entregues pagas',
      totalUserInitiated: 'Total de mensagens entregues gratuitas',
    },
    disclaimers: {
      whatsappDataDisclaimer:
        'Os valores deste relatório são recebidos direto do WhatsApp e podem ser diferentes dos mostrados na fatura. Use esse relatório apenas como estimativa do seu consumo.',
    },
  },
  en: {
    conversationTooltips: {
      freeTier: 'The first free conversations each month per WABA (WhatsApp Business Account)',
      freeEntryPoint:
        'Conversations initiated at specific points, such as WhatsApp ads and Facebook CTAs. In such cases, only the first conversation initiated by the user is free',
      freeCustomerService: 'Customer service conversations via WhatsApp are free',
      allConversations: 'The number of messages that your company has sent to individual accounts that have been successfully delivered. This metric only counts messages that arrived on the recipient\'s device and excludes messages that were not delivered, for example, when the recipient\'s device was out of service.',
      billedConversations:
        'he number of paid messages successfully delivered to individual WhatsApp accounts. The message can be initiated by the company, such as marketing, utility, or authentication.',
      regularConversations:
        'Charged WhatsApp conversations between company and users. A conversation includes all messages exchanged within a 24-hour span, starting when the first message, sent by the company is delivered.',

    },
    labels: {
      freeEntryPoint: 'Free entry point',
      freeCustomerService: 'Free customer service',
      charged: 'Paid messages',
      businessInitiated: 'Delivered paid messages',
      userInitiated: 'Delivered free messages',
      totalConversations: 'Delivered messages',
    },
    descriptions: {
      freeTierUsage: 'Free tier usage',
      chargedConversations: 'Paid messages',
      totalBusinessInitiated: 'Total delivered paid messages',
      totalUserInitiated: 'Total delivered free messages',
    },
    disclaimers: {
      whatsappDataDisclaimer:
        'The numbers in this report come directly from WhatsApp and may differ from the numbers shown on the invoice. It is best to use the report only as an estimate of your consumption.',
    },
  },
  es: {
    conversationTooltips: {
      freeTier: 'Las primeras conversaciones gratuitas cada mes por WABA (WhatsApp Business Account)',
      freeEntryPoint:
        'Conversaciones iniciadas en puntos específicos, como anuncios de WhatsApp y CTA de Facebook. En estos casos, solo la primera conversación iniciada por el usuario es gratuita',
      freeCustomerService: 'Las conversaciones de atención al cliente a través de WhatsApp son gratuitas',
      allConversations:
        'El número de mensajes que tu empresa ha enviado a cuentas individuales y que se han entregado correctamente. Esta métrica solo cuenta los mensajes que llegaron al dispositivo del destinatario y excluye aquellos que no se entregaron, por ejemplo, cuando el dispositivo del destinatario estaba fuera de servicio.',
      billedConversations:
        'El número de mensajes pagados entregados con éxito a cuentas individuales de WhatsApp. El mensaje puede ser iniciado por la empresa, como marketing, utilidad o autenticación.',
      regularConversations:
        'Son conversaciones de Whatsapp, entre empresa y usuarios, que se cobran. Una conversación incluye todos los mensajes intercambiados en un período de 24 horas, a partir de la entrega del primer mensaje enviado por la empresa.',
    },
    labels: {
      freeEntryPoint: 'Punto de entrada gratuito',
      freeCustomerService: 'Atención al cliente gratis',
      charged: 'Mensajes pagados',
      businessInitiated: 'Mensajes entregados pagados',
      userInitiated: 'Mensajes entregados gratuitos',
      totalConversations: 'Mensajes entregados',
    },
    descriptions: {
      freeTierUsage: 'Uso del free tier',
      chargedConversations: 'Mensajes pagados',
      totalBusinessInitiated: 'Total de mensajes entregados pagados',
      totalUserInitiated: 'Total de mensajes entregados gratuitos',
    },
    disclaimers: {
      whatsappDataDisclaimer:
        'Los importes de este informe se reciben directamente de WhatsApp y pueden diferir de los que se muestran en la factura. Utilice este informe solo como una estimación de su consumo.',
    },
  },
};
